import Http from "../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../core/HttpResponse";
import { Form_Supplier, Form_Update_Supplier } from "../../form/Form";
import { M_Supplier } from "../../type/Supplier.type";

export const getSuppliers = async ({
  keyword,
  page,
  perPage,
}: HttpBaseRequest) => {
  const results = await Http.get<HttpBaseResponse<HttpData<M_Supplier[]>>>({
    url: "/supplier",
    params: {
      keyword,
      page,
      perPage,
    },
  });
  return results;
};

export const getSupplier = async ({
  supplier_id,
}: {
  supplier_id?: string;
}) => {
  const results = await Http.get<HttpBaseResponse<M_Supplier>>({
    url: "/supplier/detail",
    params: {
      supplier_id,
    },
  });
  return results;
};

export const addSupplier = async ({
  supplier_address,
  supplier_name,
  supplier_phone_number,
}: Form_Supplier) => {
  const results = await Http.post({
    url: "/supplier/insert",
    data: {
      supplier_address,
      supplier_name,
      supplier_phone_number,
    },
  });
  return results;
};

export const updateSupplier = async ({
  supplier_id,
  supplier_address,
  supplier_name,
  supplier_phone_number,
}: Form_Update_Supplier) => {
  const results = await Http.post({
    url: "/supplier/update",
    data: {
      supplier_id,
      supplier_address,
      supplier_name,
      supplier_phone_number,
    },
  });
  return results;
};
